import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const ARCADE_ROUTE = "/experience/arcade";

export default function CarnivalBanner() {
  const navigate = useNavigate();
  const slideRef = useRef(null);
  const dragRef = useRef(null);
  const st = useRef({ x0: null, dx: 0, opened: false });
  const reduced = typeof window !== "undefined" && window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const openCarnival = (instant = false) => {
    if (st.current.opened) return;
    st.current.opened = true;
    if (instant || reduced) return navigate(ARCADE_ROUTE);
    slideRef.current?.classList.add("open");
    setTimeout(() => navigate(ARCADE_ROUTE), 600);
  };

  const onDown = (e) => {
    st.current.x0 = e.clientX;
    st.current.dx = 0;
    slideRef.current?.classList.add("used");
    if (!reduced) dragRef.current?.classList.add("dragging");
    dragRef.current?.setPointerCapture(e.pointerId);
  };
  const onMove = (e) => {
    const s = st.current;
    if (s.x0 === null) return;
    s.dx = e.clientX - s.x0;
    if (!reduced && dragRef.current) dragRef.current.style.transform = `translateX(${s.dx}px)`;
  };
  const onEnd = () => {
    const s = st.current;
    if (s.x0 === null) return;
    const dx = s.dx;
    s.x0 = null;
    dragRef.current?.classList.remove("dragging");
    if (Math.abs(dx) > 50) {
      if (reduced || !dragRef.current) return openCarnival(true);
      dragRef.current.classList.add("go");
      dragRef.current.style.transform = `translateX(${dx > 0 ? 420 : -560}px)`;
      st.current.opened = true;
      setTimeout(() => slideRef.current?.classList.add("open"), 350);
      setTimeout(() => navigate(ARCADE_ROUTE), 950);
    } else if (Math.abs(dx) <= 5) {
      if (dragRef.current) dragRef.current.style.transform = "";
      openCarnival();
    } else if (dragRef.current) {
      dragRef.current.style.transform = "";
    }
  };
  const onStripTap = (e) => {
    if (dragRef.current && dragRef.current.contains(e.target)) return; // truck handles its own taps
    openCarnival();
  };
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openCarnival(); }
  };

  return (
    <div className="cv">
      <div ref={slideRef} className="cv-slide" data-testid="carnival-banner" role="button" tabIndex={0}
        aria-label="Open Urban Arcade Carnival" onClick={onStripTap} onKeyDown={onKey}>
        <svg className="cv-bunt" viewBox="0 0 338 12" preserveAspectRatio="none">
          <path d="M0 1Q169 7 338 1" stroke="#F6D27A" strokeWidth=".8" fill="none" />
          <g>
            <polygon points="20,2 28,2 24,9" fill="#F2A900" /><polygon points="60,3 68,3 64,10" fill="#0F8B8D" />
            <polygon points="100,4 108,4 104,11" fill="#E04F86" /><polygon points="140,4 148,4 144,11" fill="#2E9E4F" />
            <polygon points="180,4 188,4 184,11" fill="#F2A900" /><polygon points="220,4 228,4 224,11" fill="#0F8B8D" />
            <polygon points="260,3 268,3 264,10" fill="#E04F86" /><polygon points="300,2 308,2 304,9" fill="#2E9E4F" />
          </g>
        </svg>
        <div className="cv-txt">
          <div className="cv-kick">URBAN ARCADE · CARNIVAL</div>
          <div className="cv-h">Purana Punjab <span>Mela</span></div>
          <div className="cv-hint">Drag the truck to the Mela <b>→</b></div>
        </div>
        <div className="cv-road" />
        <div ref={dragRef} className="cv-drag" data-testid="carnival-truck"
          onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onEnd} onPointerCancel={onEnd}>
          <span className="cv-trail" />
          <svg className="cv-truck" viewBox="0 0 210 120">
            <defs>
              <linearGradient id="gd" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#FFF2C2" /><stop offset=".22" stopColor="#E9C25A" />
                <stop offset=".45" stopColor="#C8922E" /><stop offset=".6" stopColor="#F3D27A" />
                <stop offset=".8" stopColor="#B07A22" /><stop offset="1" stopColor="#7E5212" />
              </linearGradient>
              <linearGradient id="gs" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stopColor="#A06C1C" /><stop offset="1" stopColor="#6A440E" />
              </linearGradient>
              <linearGradient id="gl" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#3A4048" /><stop offset=".5" stopColor="#14171C" /><stop offset="1" stopColor="#2A2E35" />
              </linearGradient>
              <pattern id="br" width="210" height="2" patternUnits="userSpaceOnUse">
                <path d="M0 .5H210" stroke="#fff" strokeOpacity=".08" strokeWidth=".5" />
              </pattern>
            </defs>
            <polygon points="8,111 202,111 196,116 14,116" fill="#000" opacity=".3" />
            <g className="bob">
              <polygon points="5,66 115,38 205,72 207,76 205,92 194,96 189,72 153,72 147,98 63,98 57,73 21,73 15,96 5,96" fill="url(#gd)" stroke="#5E3C0C" strokeWidth=".8" strokeLinejoin="miter" />
              <polygon points="5,66 115,38 205,72 207,76 205,92 194,96 189,72 153,72 147,98 63,98 57,73 21,73 15,96 5,96" fill="url(#br)" />
              <polygon points="63,98 147,98 149,90 61,90" fill="url(#gs)" opacity=".8" />
              <polygon points="5,96 15,96 18,84 5,84" fill="url(#gs)" opacity=".7" />
              <polygon points="194,96 205,92 206,84 191,84" fill="url(#gs)" opacity=".7" />
              <polygon points="62,55 115,41.5 166,57" fill="url(#gl)" />
              <path d="M75 52 L112 43" stroke="#fff" strokeOpacity=".22" strokeWidth="1.2" />
              <path d="M118 47v13" stroke="#0E1014" strokeWidth="1.6" />
              <path d="M5,68 L115,40.2 L203,73.2" stroke="#FFF7DA" strokeOpacity=".75" strokeWidth=".7" fill="none" />
              <path d="M6,74 H21 M57,73 H153 M189,73 H205" stroke="#FFF4CF" strokeOpacity=".8" strokeWidth=".8" />
              <path d="M61,89.5 H149" stroke="#5E3C0C" strokeOpacity=".6" strokeWidth=".6" />
              <path d="M90,55 V89.5 M137,58.2 V89.5 M62,56 V89.5" stroke="#5E3C0C" strokeOpacity=".55" strokeWidth=".6" />
              <path d="M62,62 L166,62" stroke="#FFF7DA" strokeOpacity=".25" strokeWidth=".5" />
              <rect x="100" y="63.5" width="6" height="1" fill="#5E3C0C" opacity=".6" /><rect x="128" y="63.5" width="6" height="1" fill="#5E3C0C" opacity=".6" />
              <polygon points="186,65.3 205,72.4 205,73.8 186,66.7" fill="#FFFFFF" />
              <polygon points="186,65.3 205,72.4 205,73.8 186,66.7" fill="#fff" opacity=".6" filter="drop-shadow(0 0 2px #fff)" />
              <rect x="4.2" y="66.5" width="1.8" height="4" fill="#FF2A2A" /><path d="M5,67.5 L24,62.7" stroke="#E0102A" strokeWidth="1.3" />
              <g>
                <circle cx="39" cy="94.5" r="17.5" fill="#15110E" /><circle cx="39" cy="94.5" r="12.5" fill="#3A3836" />
                <polygon points="39,83 49,89 49,100 39,106 29,100 29,89" fill="#C9C6BE" />
                <polygon points="39,86 46,90.5 46,98.5 39,103 32,98.5 32,90.5" fill="#E8E4DA" />
                <circle cx="39" cy="94.5" r="2.5" fill="#55524C" />
              </g>
              <g>
                <circle cx="171" cy="94.5" r="17.5" fill="#15110E" /><circle cx="171" cy="94.5" r="12.5" fill="#3A3836" />
                <polygon points="171,83 181,89 181,100 171,106 161,100 161,89" fill="#C9C6BE" />
                <polygon points="171,86 178,90.5 178,98.5 171,103 164,98.5 164,90.5" fill="#E8E4DA" />
                <circle cx="171" cy="94.5" r="2.5" fill="#55524C" />
              </g>
            </g>
          </svg>
          <svg className="cv-finger" viewBox="0 0 24 30" width="20">
            <path d="M9 3a2 2 0 0 1 4 0v9l1-.2a2 2 0 0 1 2 1.2l.6-.1a2 2 0 0 1 2.2 1.4l.4-.1a2 2 0 0 1 2.3 1.9V21c0 4-3 7-7 7h-2c-3 0-4.6-1.6-6-3.6L3 19.5a2 2 0 0 1 3-2.5L9 19.5z" fill="#fff" stroke="#3A2610" strokeWidth="1.3" />
          </svg>
        </div>
        <div className="cv-open"><small>WELCOME TO THE</small><b>Purana Punjab Mela</b></div>
      </div>
    </div>
  );
}
